import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import router from "./routes/Router"
import ModConfig from "./modules/ModConfig"

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

let notFound = false

require('./scss/default.scss')

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

ModConfig.load(window.location.href).then(config => {  
  let messages = config.messages || {}
  const i18n = new VueI18n({
    locale: "de",
    messages
  })
  if(config.specs){
  Vue.prototype.$specs = config.specs
  }else{
    notFound = true
  }
  
  new Vue({
    router,
    i18n,
    render: h => h(App),
    mounted() {
      const supported = (() => {
        const nav = navigator.userAgent.toLocaleLowerCase()
        const isNotIe9 = ((nav.indexOf('msie') != -1) ? parseInt(nav.split('msie')[1]) : 11) !== 9
        const supportSvg = !!(document.createElementNS && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect)
        return isNotIe9 && supportSvg
      })();
      if (supported) {
        if(notFound){
this.$router.replace("/notfound")
        }else{
        this.$router.replace("/")
        }
      } else {
        this.$router.replace("/notsupported")
      }

    }
  }).$mount('#app')

}).catch(err => {
  console.error(err);
  router.replace("/notfound")  
})
